import { render, staticRenderFns } from "./GymPassFailure.vue?vue&type=template&id=6b8e640e"
import script from "./GymPassFailure.vue?vue&type=script&lang=js"
export * from "./GymPassFailure.vue?vue&type=script&lang=js"
import style0 from "./GymPassFailure.vue?vue&type=style&index=0&id=6b8e640e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports